import { render, staticRenderFns } from "./Expert2CommentEdit.vue?vue&type=template&id=6313f856&scoped=true&"
import script from "./Expert2CommentEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2CommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313f856",
  null
  
)

export default component.exports